import { Text } from 'react-native'
import { CardBenefitsComponentPoint } from './point'
import { fontFamilies } from '@/src/common/theme'
import { CardBenefit } from '../statsig/store/useCardBenefitsParameterStore'

export function CardBenefitsComponentsHowToRedeem({
  howToRedeem,
  creditRedemption,
  ctaAction,
}: {
  howToRedeem: CardBenefit['how_to_redeem']
  creditRedemption: string | undefined
  ctaAction: CardBenefit['cta_action']
}) {
  return ctaAction === 'enrollment_full' ? null : (
    <>
      <Text
        style={{
          fontSize: 14,
          fontFamily: fontFamilies['PlusJakartaSans-Regular'],
          fontWeight: 400,
        }}
      >
        {creditRedemption === 'BONUS_POINTS'
          ? "Here's how it works:"
          : 'How to redeem your benefit:'}
      </Text>
      {howToRedeem.map((instruction) => (
        <CardBenefitsComponentPoint text={instruction} key={instruction} />
      ))}
    </>
  )
}
